import { ColorPicker } from "./ColorPicker";

type ShadowValue = {
  color: string;
  opacity: number;
  x: number;
  y: number;
  blur: number;
};

type ShadowPickerProps = {
  value: ShadowValue;
  onChange: (updates: Partial<ShadowValue>) => void;
  className?: string;
};

export function ShadowPicker({
  value,
  onChange,
  className,
}: ShadowPickerProps) {
  return (
    <ColorPicker
      className={className}
      value={value.color}
      opacity={value.opacity}
      onChange={(color) => onChange({ color })}
      onOpacityChange={(opacity) => onChange({ opacity })}
      presetColors={[]}
      shadow={{ x: value.x, y: value.y, blur: value.blur }}
      onShadowChange={(updates) => onChange(updates)}
    />
  );
}
